import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VitalityblastComponent } from './vitalityblast/vitalityblast.component';
import { IndiatourmatchComponent } from './indiatourmatch/indiatourmatch.component';
import { WomensinternationalComponent } from './womensinternational/womensinternational.component';
import { FaqsComponent } from './faqs/faqs.component';
import { RegisterYourInterestComponent } from './register-your-interest/register-your-interest.component';
import { RegisterYourInterestWomenComponent } from './register-your-interest-women/register-your-interest-women.component';
const routes: Routes = [
  {path: "vitalityblast", component: VitalityblastComponent},
  {path: "club/signup", component: IndiatourmatchComponent},
  {path: "englandwomensinternational", component: WomensinternationalComponent},
  {path: "faqs", component: FaqsComponent},
  {path: "registeryourinterest", component: RegisterYourInterestComponent},
  {path: "supportyourcountyold", component: RegisterYourInterestWomenComponent}
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VitalityblastRoutingModule { }
